import { ReactNode, useEffect, useState } from 'react'
import { useDebounce } from 'react-use'
import { ControlSize } from 'types'
import { TextInput } from 'ui'

type Props = {
    children?: ReactNode
    className?: string
    defaultValue?: string
    placeholder?: string
    size: ControlSize
    onChange: (value: string) => void
}

const UsernameFieldInput = ({ children, className, defaultValue = '', placeholder, size, onChange }: Props) => {
    const [value, setValue] = useState<string>(defaultValue)

    useDebounce(
        () => {
            onChange(value)
        },
        800,
        [value]
    )

    useEffect(() => {
        setValue(defaultValue)
    }, [defaultValue])

    return (
        <TextInput
            className={className}
            forceDisable1Password
            placeholder={placeholder}
            size={size}
            value={value}
            onChange={setValue}
        >
            {children}
        </TextInput>
    )
}

export default UsernameFieldInput
